import { Base } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class MenuItem extends Base {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'MenuItem',
    refs: ['close', 'btn'],
    emits: ['open'],
    options: {
      depth: {
        type: Number,
      },
    },
  };

  /**
   * Mount component
   * @returns {void}
   */
  mounted() {
    this.open = false;
  }

  /**
   * Click on item which has submenu
   * @returns {void}
   */
  onClick() {
    this.openSubmenu();
  }

  /**
   * Close menu item
   * @param  {object} e node element clicked
   * @returns {void}
   */
  onCloseClick(e) {
    e.stopPropagation();
    this.closeSubmenu();
  }

  /**
   * Open menu nothing more
   * @returns {void}
   */
  openSubmenu() {
    if (this.open) return;

    this.$el.classList.add('menu__item--open');
    this.$emit('open');
    this.open = true;
  }

  /**
   * Close menu nothing more
   * @returns {void}
   */
  closeSubmenu() {
    this.$el.classList.remove('menu__item--open');
    this.open = false;
  }
}
